import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=4ef40552&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=4ef40552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef40552",
  null
  
)

export default component.exports